<template>
  <div>
    <div v-if="!!campusId">
      <el-row>
        <el-col :span="8">
          <el-date-picker class="cs-appointmentList-searchDate" v-model="searchDate" type="daterange" align="center"
            unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
            :picker-options="pickerOptions" size="medium" @change="onSearchDateChange"></el-date-picker>
        </el-col>
        <el-col :span="10">
          &nbsp;
        </el-col>
        <el-col :span="6">
          <el-input class="cs-appointmentList-searchPhone" placeholder="按号码搜索" size="medium" clearable
            suffix-icon="el-icon-search" v-model.trim="searchPhone" @change="onSearchPhoneChanged"
            @keyup.enter.native="onSearchPhoneChanged"> </el-input>
        </el-col>
      </el-row>
    </div>
    <pagination v-loading="loading" :data="videoAppointmentListData" :option="paginationOption" @edit="edit"
      @search="search" @loadData="search" @pageSizeChange="pageSizeChange" @currentPageChange="currentPageChange"
      @customEvent="customEventHandler"></pagination>
    <el-dialog :center="true" :close-on-click-modal="false" width="700px" :visible.sync="infoVisible" top="3vh">
      <avappInfo @close="onCloseInfo" @reload="onReload" :dataIn="infoData"></avappInfo>
    </el-dialog>
    <el-dialog v-if="avappWatchApproveVisible" title="确认观看" :center="true" :close-on-click-modal="true" width="50%"
      :visible.sync="avappWatchApproveVisible" top="3vh">
      <avappWatchApprove class="cs-calendarDialog" :isView="true" :dataIn="avappWatchApproveData"
        @close="onCloseAvappWatchApprove"></avappWatchApprove>
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>
.cs-appointmentList-searchDate {
  width: auto;
  float: left;

  .el-range-separator {
    z-index: 99;
  }
}

.cs-appointmentList-searchPhone {
  float: right;
}
</style>

<script>
import pagination from "../common/pagination";
import global_ from "@/core/global";
import avappInfo from "./avappInfo";
import avappWatchApprove from "./avappWatchApprove";
import { getVideoAppointmentList } from "../../service/videoAppointment.service";
import { getStore, setStore, addMonth, formatDate } from "../../config/mUtils";
let moment = require("moment");

export default {
  props: {
    isActive: Boolean,
    campusId: Number | String
  },
  data() {
    return {
      infoData: {
        id: 0,
        isCancel: false,
      },
      isLoadedData: false,
      avappWatchApproveVisible: false,
      avappWatchApproveData: {},
      infoVisible: false,
      loading: false,
      videoAppointmentListData: [],
      paginationOption: {},
      pageSize: 20,
      searchPhone: "",
      searchDate: "",
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      }
    };
  },
  async created() {
  
    this.searchDate = [];
    let today = new Date();
    let endDate = moment().add(7, "days").toDate();

    this.searchDate.push(today);
    this.searchDate.push(endDate);

    this.initData();
  },
  components: {
    pagination,
    avappInfo,
    avappWatchApprove
  },
  methods: {
    initData() {
      this.loadPaginationOption();
      this.search();
    },
    loadPaginationOption() {
      if (this.USERMANAGER.isStudent) {
        this.paginationOption = {
          displayPagination: true,
          hasEditButton: false,
          editButtonText: "付款",
          hasAddButton: false,
          hasSearch: false,
          hasDeleteButton: false,
          displayStudent: false,
          hasStudentVideoButton: true,
          isNotV1: true,
        };
      } else {
        this.paginationOption = {
          displayPagination: true,
          hasEditButton: true,
          editButtonText: "详情",
          hasAddButton: false,
          hasSearch: false,
          hasDeleteButton: false,
          displayStudent: true,
          hasStudentVideoButton: true,
          isNotV1: true,
        };
      }
    },
    loadVideoAppointmentList(pageData) {
      this.loading = true;

      getVideoAppointmentList(pageData)
        .then(result => {
          if (!!result && result.success) {
            this.videoAppointmentListData = result.data;
          }
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
          this.loading = false;
        });
    },
    search(pageData) {
      if (!this.isActive) {
        return;
      }
      this.isLoadedData = true;
      let searchData = this.getSearchPageData(pageData);
      this.loadVideoAppointmentList(searchData);
    },
    pageSizeChange(value) {
      this.pageSize = value;
    },
    currentPageChange(value) {
      this.videoAppointmentListData.CurrentPage = value;
    },
    getSearchPageData(pageData) {
      if (typeof pageData == "undefined" || pageData == 1) {
        pageData = {
          pageNumber: 1
        };
      }

      let startDate = "";
      let endDate = "";
      if (!!this.searchDate && this.searchDate.length == 2) {
        startDate = formatDate(this.searchDate[0]);
        endDate = formatDate(this.searchDate[1]);
      }

      let additionalFilter = {
        CampusId: this.campusId
      };

      let searchData = {
        pageSize: this.pageSize,
        keyWord: this.searchPhone,
        startDate: startDate,
        endDate: endDate,
        additionalFilter: additionalFilter
      };
      searchData = $.extend({}, pageData, searchData);
      return searchData;
    },
    onSearchDateChange() {
      this.search();
    },
    onSearchPhoneChanged() {
      this.search();
    },
    edit(index, row) {
      this.showInfo(row.Id);
    },
    showInfo(id){
      let data = {
        id: id,
        isCancel: false
      }
      this.infoData = data;
      this.infoVisible = true;
    },
    onCloseInfo() {
      this.infoVisible = false;
    },
    onReload() {
      this.$emit("reload");
      this.infoVisible = false;
      this.search();
    },
    customEventHandler(data) {
      if (data.name == "changeStatus") {
        let infoModel = {
          id: data.id,
          isCancel: false
        }
        if (data.status == 6) {
          infoModel.isCancel = true;
        }
        this.infoData = infoModel;
        this.infoVisible = true;
      } else if (data.name == "watchApprove") {
        this.avappWatchApproveData = { id: data.id, phone: data.phone, courseWeekString: data.courseWeekString };
        this.avappWatchApproveVisible = true;
      } else if (data.name == "view") {
        this.showInfo(data.id);
      }
      else {
        this.$emit("customEvent", data);
      }

    },
    onCloseAvappWatchApprove() {
      this.avappWatchApproveVisible = false;
      this.search();
    },
  },
  watch: {
    isActive: function () {
      if (this.isActive && !this.isLoadedData) {
        this.search();
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/addVideoAppointment/appointmentList.vue